import { Navigate } from 'react-router-dom';
import './styles.css';
import Datasets from './pages/Datasets';
import DevicesAdmin from './pages/DevicesAdmin';
import HistoryShowcase from './pages/HistoryShowcase';
import Live from './pages/Live';
import LiveDevices from './pages/LiveDevices';
import Replay from './pages/Replay';
import type { PortalModule } from '../types';

const ccs: PortalModule = {
  id: 'ccs',
  title: 'CCS 采集',
  summary: 'CO₂ 捕集中试装置 · P&ID 数据面板 · 历史回放',
  owner: '碳捕集与能源利用数智实验室',
  status: 'active',
  visibility: 'public',
  nav: { order: 1, show: true },
  minRole: 'graduated_student',
  menuLabel: 'CCS 系统',
  tabs: [
    { label: '监控', to: '/ccs/live', matches: ['/ccs/live'] },
    { label: '回放', to: '/ccs/history', matches: ['/ccs/history', '/ccs/datasets'] },
    { label: '采集', to: '/ccs', matches: ['/ccs'] },
  ],
  publicRoutes: [
    {
      path: 'history',
      element: <HistoryShowcase />,
      handle: { navLabel: '历史回放', mainClass: 'page-wide' },
    },
    { path: 'live', element: <LiveDevices />, handle: { navLabel: '实时' } },
    { path: '*', element: <Navigate to="/ccs/history" replace /> },
  ],
  authRoutes: [
    { index: true, element: <Datasets /> },
    { path: 'live/:deviceId', element: <Live />, handle: { mainClass: 'page-wide page-live' } },
    {
      path: 'datasets/:id',
      element: <Replay />,
      handle: { mainClass: 'page-wide page-replay' },
    },
    { path: 'admin/devices', element: <DevicesAdmin /> },
  ],
};

export default ccs;